import React, { useContext } from "react";
import { Button, CircularProgress } from "@mui/material";
import { Link } from "react-router-dom";
import CommercialAirlineNavigationBar from "../../../../../components/element/CommercialAirlineNavigationBar";
import PrintIcon from "../../../../../assets/images/print_icon.svg";
import { StorageContext } from "../../../../../services/StorageProvider";
import {
  ApprovalState,
  AirportType,
  DisputeStatus,
  FLIGHT_PLAN_STATUS,
} from "../../../../../utils/constants";
import {
  getAirportData,
  getFlightNumber,
  isDepartureAirportDomestic,
} from "../../../../../utils/utils";
import ROUTE_PATHS from "../../../../../utils/routePaths";
import "../EditFlightRoster.css";

const EditFlightRosterHeader = ({
  isEditing,
  isAAUser,
  flightPlanDetail,
  flightPlanApprovals,
  isFlightPlanApprovalsLoading,
  onClickCancelFlight,
  onClickEdit,
  onClickConfirm,
  onClickCancel,
  onClickSave,
  isLoadingConfirm,
  isLoadingSave,
  onClickPrint,
  airlineName,
}) => {
  const { airportData } = useContext(StorageContext);
  const isCanceled = flightPlanDetail?.status === FLIGHT_PLAN_STATUS.CANCELLED;
  const isActionLoading = Boolean(isFlightPlanApprovalsLoading);
  const isApproved =
    flightPlanDetail?.status === FLIGHT_PLAN_STATUS.AA_APPROVAL || isAAUser
      ? flightPlanApprovals?.some(
        (item) => item.approvalState === ApprovalState.APPROVED_BY_AA
      )
      : flightPlanApprovals?.some(
        (item) => item.approvalState === ApprovalState.APPROVED_BY_AIRLINE
      );

  return (
    <div>
      <CommercialAirlineNavigationBar showHeaderBar={false} />
      <header className="edit-flight-roster-header">
        <div className="edit-flight-roster-header-bar-container">
          <div className="edit-flight-roster-header-bar">
            <div className="edit-flight-roster-left">
              <div className="navigation-header">
                <Link
                  to={ROUTE_PATHS.COMMERCIAL_AIRLINE_HOME}
                  className="navigation-header-link"
                >
                  Home/
                </Link>
                <Link
                  to={ROUTE_PATHS.COMMERCIAL_AIRLINE_FLIGHT_ROSTER}
                  className="navigation-header-link"
                >
                  Flight Roster/
                </Link>
                Edit
              </div>
            </div>
            <p className="edit-flight-roster-center">{`${getFlightNumber(
              flightPlanDetail
            )} ${airlineName ? `- ${airlineName}` : ""}`}</p>
            <div className="edit-flight-roster-right">
              {!isCanceled ? (
                isEditing ? (
                  <>
                    <Button
                      variant="contained"
                      className="cancel"
                      onClick={onClickCancel}
                    >
                      Cancel
                    </Button>
                    <Button variant="contained" onClick={onClickSave}>
                      {isLoadingSave ? (
                        <CircularProgress size={20} color="inherit" />
                      ) : (
                        "Save"
                      )}
                    </Button>
                  </>
                ) : (
                  <>
                    {isApproved && isAAUser && (
                      <Button
                        variant="contained"
                        className="print-button"
                        onClick={onClickPrint}
                      >
                        <img src={PrintIcon} alt="print" />
                        Print
                      </Button>
                    )}
                    <Button
                      variant="contained"
                      className="cancel-flight"
                      onClick={onClickCancelFlight}
                    >
                      Cancel Flight
                    </Button>
                    {flightPlanDetail?.status ===
                      FLIGHT_PLAN_STATUS.AA_APPROVAL ? (
                      <></>
                    ) : (
                      <>
                        {!isActionLoading && !isApproved && (
                          <Button
                            variant="contained"
                            className="cancel"
                            onClick={onClickEdit}
                          >
                            Edit
                          </Button>
                        )}
                        {!isActionLoading && !isApproved && (
                          <Button
                            variant="contained"
                            className="confirm"
                            disabled={
                              (isAAUser && isDepartureAirportDomestic(airportData, flightPlanDetail?.departureAirportId, AirportType) &&
                                flightPlanDetail?.disputeStatus ===
                                DisputeStatus.RAISED)
                            }
                            onClick={onClickConfirm}
                          >
                            {isLoadingConfirm ? (
                              <CircularProgress size={20} color="inherit" />
                            ) : (
                              "Confirm"
                            )}
                          </Button>
                        )}
                      </>
                    )}
                  </>
                )
              ) : null}
            </div>
          </div>
        </div>
      </header>
    </div>
  );
};

export default EditFlightRosterHeader;
